import { createInfiniteQuery, createMutation, createQuery } from '../../libs';

import { PaginatedNotifications, UnreadNotifications } from './models';

const url = 'notifications';

export const useGetNotifications = createInfiniteQuery<PaginatedNotifications>(
  {
    method: 'get',
    url: `${url}`,
  },
  {
    staleTime: 0,
    keepPreviousData: false,
  }
);

// TODO: add types to the following service
export const useReadNotification = createMutation<
  UnreadNotifications,
  unknown,
  'id',
  unknown
>({
  method: 'put',
  url: `${url}/:id/make-read`,
});

export const useReadPushNotification = createMutation<unknown, unknown, 'id', unknown>({
  method: 'put',
  url: `${url}/make-read/notification-template/:id`,
});

// TODO: add types to the following service
export const useMakeNotificationDeleted = createMutation<
  UnreadNotifications,
  unknown,
  'id',
  unknown
>({
  method: 'delete',
  url: `${url}/:id`,
});

export const useGetUnreadNotificationsQuery = createQuery<
  UnreadNotifications,
  UnreadNotifications
>({
  method: 'get',
  url: `${url}/unread/count`,
});
